import { Button, Icon, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import { CATEGORIES } from '@habity/constants';
import { useFilters } from '~/hooks/useFilters';
import { useHomesStore } from '~/store/useHomesStore';
import { getFilterArrayValues } from '@habity/services';
import { CategoryType } from '@habity/types';
import { getCategoryIcon } from '~/constants';

interface CategoriesProps {
  ignoreSearch?: boolean;
  hideTitle?: boolean;
}

export function Categories({
  ignoreSearch = false,
  hideTitle = false,
}: CategoriesProps) {
  const filters = useHomesStore((state) => state.filters);
  const { performSearch } = useFilters();

  const { categories } = filters || {};

  const onToggle = (values: CategoryType[]) => {
    const newCategories = categories
      ? getFilterArrayValues(values, categories)
      : values;
    performSearch({ filters: { categories: newCategories }, ignoreSearch });
  };

  return (
    <Stack spacing="2">
      {!hideTitle && (
        <Text size="md" fontWeight="medium">
          Bostadstyp
        </Text>
      )}
      <SimpleGrid minChildWidth="150px" rowGap="2" columnGap="2">
        {CATEGORIES.map((category) => {
          const isActive = categories?.some((r) => category.values.includes(r));
          return (
            <Button
              key={category.label}
              flex="1"
              size="md"
              fontSize="sm"
              variant="outline"
              h="80px"
              borderColor="blackAlpha.400"
              onClick={() => onToggle(category.values)}
              isActive={isActive}
              _active={{
                backgroundColor: 'blackAlpha.50',
                borderColor: 'black',
                borderWidth: '2px',
              }}
            >
              <Stack justifyContent="center" alignItems="center" spacing="2">
                <Icon as={getCategoryIcon(category.values[0])} boxSize="24px" />
                <Text size="sm">{category.label}</Text>
              </Stack>
            </Button>
          );
        })}
      </SimpleGrid>
    </Stack>
  );
}
